/* import __COLOCATED_TEMPLATE__ from './dds-panel.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type Intl from 'ember-intl/services/intl';
import type SiteService from '@ebiz/ember-aditools-site/services/aditools-site';
import type CircuitService from '../services/circuit';
import type FilterService from '../services/filter';
import type { ProductRow } from '../services/state';

/**
 * @typedef DDSPanelSignature
 * @property {object} Args
 * @property {function(void): void} Args.selectedPartChanged
 */
interface DDSPanelSignature {
  Args: {
    products: ProductRow[];
    selectedPartChanged: () => void;
  };
}

export default class DDSPanel extends Component<DDSPanelSignature> {
  @service declare intl: Intl;
  @service('aditools-site') declare siteconfig: SiteService;
  @service declare circuit: CircuitService;
  @service declare filter: FilterService;

  @action onChange(event: Event) {
    if (event.target && event.target instanceof HTMLSelectElement) {
      this.circuit.partNumber = event.target.value;
      this.args.selectedPartChanged();
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    DdsPanel: typeof DDSPanel;
  }
}
